// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3Pf5e","legacyBtn":"MutateMid_legacyBtn__wo_94"};